module.exports = __webpack_public_path__ + "media/images/sp/specials/common/special_c_28-3d6f2b0de515b21b5e04546b5f1d7392.jpg";